// extracted by mini-css-extract-plugin
module.exports = {"section":"testimonials_section__52esg","cover":"testimonials_cover__cqWM9","slider":"testimonials_slider__LcEE2"};